"use client";
import React, {useRef} from "react";
import {SDialogFC, SDialogProps} from "@/Master/SDialogFC/SDialogFC";
import {QueryOrderResponse, ShopItem, XtgChannle, XtgConfigListResponse} from "@/app/_api/types/store";
import $http from "@/app/_api";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {PayWaitingDialogFC} from "@/app/(pay)/UI/PayWaitingDialog/PayWaitingDialog";
import PayUtil from "@/Core/Pay/PayUtil";
import {hideForceLoading, showForceLoading} from "@/app/_dialogs/LoadingForceDialog/LoadingForceDialogFC";
import Util from "@/Master/Util";
import {PayIOSTipsDialogFC} from "@/app/(pay)/UI/PayIOSTipsDialog/PayIOSTipsDialog";
import ShopMgr from "@/app/(shop)/ShopMgr";
import {useAppDispatch, useAppSelector} from "@/app/storeHooks";
import {LoginType, selectUserInfo} from "@/app/userSlice";
import {SpecialGiftPackDialogFC} from "@/app/(shop)/UI/SpecialGiftPackDialog/SpecialGiftPackDialog";
import {FirstChargeGiftPackDialogFC} from "@/app/(shop)/UI/FirstChargeGiftPackDialog/FirstChargeGiftPackDialog";
import styles from "./PaySelectionDialog.module.css";
import {PayChannel} from "@/app/(pay)/PayChannel";
import BigTips from "@/Master/BigTips";
import {PayStatus} from "@/app/(pay)/types";
import {RewardDialogFC} from "@/app/_dialogs/RewardDialog/RewardDialog";
import {VisitorRechargeDialogFC} from "@/app/(shop)/UI/VisitorRechargeDialog/VisitorRechargeDialog";
import RouterMgr from "@/Core/RouterMgr";
import {getPaymentItemsAsync} from "@/app/(pages)/paymentItemsAPI";

interface PaySelectionDialogProps extends SDialogProps {
    data: XtgConfigListResponse;
    shopItem: ShopItem;
}

export const PaySelectionDialogFC: React.FC<PaySelectionDialogProps> = (props) => {
    const {fcKey, isOpen, data, shopItem} = props;
    if (!isOpen) return null;

    const dispatch = useAppDispatch();
    const userInfo = useAppSelector(selectUserInfo);
    const currentItem = useRef<XtgChannle>({} as XtgChannle);

    const showVisitorMobileDialog: () => void = async () => {
        ShopMgr.showVisitorMobileDialog(() => {
            onClickOpenPaymentLink(currentItem.current)
        })
    }

    // 接口校验手机号是否注册
    const checkPhoneRegister = async () => {
        const result = await $http.Auth.checkPhoneRegister({
            areaCode: ShopMgr.getVisitorAreaNo,
            mobile: ShopMgr.getVisitorMobile
        });
        return result.isRegistered;
    }

    const onBeforeOpenPaymentLink = async (row: XtgChannle) => {
        currentItem.current = row;
        // 判断用户身份，根据用户身份执行不同充值逻辑
        if (userInfo.loginType == LoginType.visitor) {
            showVisitorMobileDialog();
            if (ShopMgr.getVisitorMobile) {//验证手机号是否有问题
                const isPhoneRegister = await checkPhoneRegister();
                // if (isPhoneRegister) {
                    //验证是否充值过，正常值允许首次充值
                    // ShopMgr.showForcedLoginDialog(() => {
                        SDialogManagerFC.closeDialog(fcKey);
                        // 判断是否打开特价礼包弹窗
                        if (SDialogManagerFC.getFCKey(SpecialGiftPackDialogFC)) {
                            SDialogManagerFC.closeDialog(SDialogManagerFC.getFCKey(SpecialGiftPackDialogFC))
                        }
                        // 判断是否打开首充礼包弹窗
                        if (SDialogManagerFC.getFCKey(FirstChargeGiftPackDialogFC)) {
                            SDialogManagerFC.closeDialog(SDialogManagerFC.getFCKey(FirstChargeGiftPackDialogFC))
                        }
                    // });
                // } else {
                //     onClickOpenPaymentLink(currentItem.current);
                // }
            }
        } else {
            onClickOpenPaymentLink(currentItem.current);
        }

    }

    const onClickOpenPaymentLink = async (row: XtgChannle) => {
        showForceLoading();
        const responseData = await $http.Store.getXtgLink({
            channel: row.pay_type,
            extraInfo: {
                itemsId: shopItem.id,
                itemsType: shopItem.itemsType,
                ks: data.ks,
                payAmount: shopItem.money,
                productId: shopItem.productId,
                userId: userInfo.userId,
            },
            platformOrderId: data.ks,
            sessionId: data.session_id,
        });
        hideForceLoading();

        if (responseData?.xtg_link) {
            if (Util.isIOS) {
                SDialogManagerFC.openDialog(PayIOSTipsDialogFC, {
                    fcKey: SDialogManagerFC.getFCKey(PayIOSTipsDialogFC),
                    onClose: () => {
                        openPayLink(responseData.xtg_link, row.pay_type);
                    }
                });
            } else {
                openPayLink(responseData.xtg_link, row.pay_type);
            }
        }
    };

    const onRewardAni = (item: ShopItem, data: QueryOrderResponse) => {
        SDialogManagerFC.openDialog(RewardDialogFC, {
            fcKey: SDialogManagerFC.getFCKey(RewardDialogFC),
            onClose: () => {
                //todo 后面奖励效果通过更新用户数据变动后更新顶部的数值滚动效果
                // SRewardUIPresenter.Instance.PlayRewardAnimation(item.gc, item.sc, EffectType.FlyIcon);
                // ShopMgr.checkUserForcedReg();
                //ShopMgr.checkShowRegDialog();
                if (SDialogManagerFC.getFCKey(FirstChargeGiftPackDialogFC)) SDialogManagerFC.closeDialog(
                    SDialogManagerFC.getFCKey(FirstChargeGiftPackDialogFC)
                )
                if (SDialogManagerFC.getFCKey(VisitorRechargeDialogFC)) SDialogManagerFC.closeDialog(
                    SDialogManagerFC.getFCKey(VisitorRechargeDialogFC)
                )
                if (SDialogManagerFC.getFCKey(SpecialGiftPackDialogFC)) SDialogManagerFC.closeDialog(
                    SDialogManagerFC.getFCKey(SpecialGiftPackDialogFC)
                )
                if (userInfo.loginType == LoginType.visitor) {
                    RouterMgr.signup([['from','payOk']]);
                }
            },
            gcCount: item.gc,
            scCount: data.totalSc,
        })
    }

    const openPayLink = (xtg_link: string, pay_type: string) => {
        if (!xtg_link) {
            return;
        }
        window.open(xtg_link);
        SDialogManagerFC.closeDialog(fcKey);
        SDialogManagerFC.openDialog(PayWaitingDialogFC, {
            fcKey: SDialogManagerFC.getFCKey(PayWaitingDialogFC),
            ks: data.ks,
            pType: pay_type,
            shopItem: shopItem,
            onClose: async () => {
                let responseData: QueryOrderResponse = await $http.Store.queryOrder({
                    ks: data.ks,
                    ptype: pay_type
                });
                console.log(responseData)
                if (!responseData?.orderStatus) {
                    BigTips.showMsg(`No payment result found.`);
                }
                if (responseData.orderStatus !== PayStatus.WAITING) {
                    if (responseData.orderStatus == PayStatus.SUCCESS) {
                        onRewardAni(shopItem, responseData);
                        dispatch(getPaymentItemsAsync({userId: userInfo.userId, itemsType: 1}));
                        dispatch(getPaymentItemsAsync({userId: userInfo.userId, itemsType: 2}));
                        // console.log("支付结果已生成", responseData);
                        // onCloseCall();
                    } else {
                        BigTips.showMsg(`${PayUtil.getPayStatusName(responseData.orderStatus)}`);
                    }
                }
                if (responseData.orderStatus === PayStatus.WAITING) {
                    BigTips.showMsg(`Waiting for payment.`);
                }
            }
        });
    }

    const isIosCanApplePay = () => {
        const window1 = (window as any);
        if (window1.ApplePaySession) {
            try {
                return window1.ApplePaySession.canMakePayments();
            }
            catch (ex) {

            }
        }
        return false;
    }

    const getChannelList = () => {
        const newChannel:XtgChannle[] = [];
        if (data.channel){
            for (let i = 0; i < data.channel.length; i++) {
                const item = data.channel[i];
                if (item.attribution == PayChannel.ApplePay){
                    if (!isIosCanApplePay()){//不支持苹果支付 屏蔽这个支付方式
                        continue;
                    }
                }
                newChannel.push(item);
            }
        }
        return newChannel;
    }

    return (
        <SDialogFC
            fcKey={fcKey}
            isOpen={isOpen}
            mode="Center"
            isBodyPad={false}
            title={
                <p style={{marginBottom: ".4rem", fontSize: ".6rem", fontWeight: "bold"}}>
                    Choose Payment Method
                </p>
            }
            bottom={
                <div className={styles.footer}>
                    <img className={styles.icon_left} src="/img/payment-selection/icon_left.webp" alt=""/>
                    <div className={styles.footer_font}>Secure and Fast</div>
                    <img className={styles.icon_right} src="/img/payment-selection/icon_right.webp" alt=""/>
                </div>
            }
        >
            <section className={styles.content}>
                <section className={styles.payment_list_wrapper}>
                    {getChannelList().map((item, index) => (
                        <section
                            key={index}
                            className={`${styles.payment_list_item} btn`}
                            onClick={() => onBeforeOpenPaymentLink(item)}
                        >
                            <img
                                src={`/img/pay/item/${PayUtil.getPayChannelName(item.attribution)}`}
                                alt={item.atr_label}
                            />
                        </section>
                    ))}
                </section>
            </section>
        </SDialogFC>
    );
};
